<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "ncb_recovery"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#NCBRecovery">
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>NCB Recovery</h3>
      </div>
    </div>
<div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="NCBRecovery">
      <div class="risk row" v-if="ncbRecoveryData.ncbApplicable.visibility">
        <!--NCB Applicable* starts-->
        <div class="form-group col-lg-5 col-md-5 col-sm-6 p-0">
          <div class="form-group d-flex">
            <p class="mr-5">NCB Applicable*</p>
            <input
              value="YES"
              type="radio"
              class="input-radio bgc-radio ml-2"
              name="radiobutton"
              id="yes"
              v-model="ncbRecoveryData.ncbApplicable.value"
              @change="ncbApplicableChange()+resetNcbData()"
            />
            <label class="custom-control-label labelstyle1" for="yes">
              <span class="self-inspection">Yes</span>
            </label>
            <input
              value="NO"
              type="radio"
              class="input-radio bgc-radio ml-5"
              name="radiobutton"
              id="no"
              v-model="ncbRecoveryData.ncbApplicable.value"
              @change="ncbApplicableChange()+resetNcbData()"
            />
            <label class="custom-control-label labelstyle1" for="no">
              <span class="self-inspection">No</span>
            </label>
          </div>
        </div>
      </div>
      <!--NCB Applicable* ends-->
      <div class="risk row" v-if="ncbRecoveryData.ncbApplicable.value == 'YES'">
        <!--NCB Taken from* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="ncbRecoveryData.ncbTakenFrom.visibility">
          <div class="row form-group">
            <float-label label="NCB Taken from*" :fixed="isFloat(ncbRecoveryData.ncbTakenFrom.value)"> 
              <select
                v-model="ncbRecoveryData.ncbTakenFrom.value"
                v-evolvews="ncbRecoveryData.ncbTakenFrom"
                type="text"
                maxlength="30"
                :class="{'bgc-error-field':ncbRecoveryData.ncbTakenFrom.errorText !== '',}"
                class="form-control"
                placeholder="NCB Taken from*"
              >
              <option disabled selected value="">NCB Taken from*</option>
              <option v-for="ncbtaken in previousPolicyDetailsObj.ncbTakenFrom" :key="ncbtaken.code" :value="ncbtaken.code">{{ncbtaken.name}}</option>
              </select>
            </float-label>
              <span class="error-text" v-if="ncbRecoveryData.ncbTakenFrom.errorText !== ''">
                  {{ncbRecoveryData.ncbTakenFrom.errorText}}</span>
          </div>
        </div>
        <!--NCB Taken from* ends-->
        <!--Applicable NCB %* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="ncbRecoveryData.currentYearNcb.visibility">
          <div class="row form-group">
            <float-label
                label="Applicable NCB%*"
                :fixed="isFloat(ncbRecoveryData.currentYearNcb.value)">
                <select
                  class="form-control"
                  placeholder="Applicable NCB%*"
                  v-model="ncbRecoveryData.currentYearNcb.value"
                  :class="{'bgc-error-field':ncbRecoveryData.currentYearNcb.errorText !== '',}"
                  v-evolvews="ncbRecoveryData.currentYearNcb">
                  <option disabled selected value="">Applicable NCB%*</option>
                  <option value="0">0</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="35">35</option>
                  <option value="45">45</option>
                  <option value="50">50</option>
                </select>
              </float-label>
              <span
                class="error-text"
                v-if="ncbRecoveryData.currentYearNcb.errorText !== ''"
                >{{ ncbRecoveryData.currentYearNcb.errorText }}</span>
          </div>
          <span class="loader-small-ncb loader-show-class" v-show="loaderShowNcb">
              <img src="@/assets/images/loader.gif" alt="done">
          </span>
        </div>
        <!--Applicable NCB %* ends-->
        <!--Previous Policy NCB %* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="ncbRecoveryData.previousPolicyNcb.visibility">
          <div class="row form-group">
            <float-label
            label="Previous Policy NCB %*"
            :fixed="isFloat(ncbRecoveryData.previousPolicyNcb.value)">
            <select
              class="form-control"
              placeholder="Previous Policy NCB %* "
              v-model="ncbRecoveryData.previousPolicyNcb.value"
              @change="getApplicableNcb()"
              :class="{'bgc-error-field':ncbRecoveryData.previousPolicyNcb.errorText !== '',}"
              v-evolvews="ncbRecoveryData.previousPolicyNcb">
              <option disabled selected value="">Previous Policy NCB %*</option>
              <option value="0">0</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="35">35</option>
              <option value="45">45</option>
              <option value="50">50</option>
            </select>
            </float-label>
            <span
              class="error-text"
              v-if="ncbRecoveryData.previousPolicyNcb.errorText !== ''">{{ ncbRecoveryData.previousPolicyNcb.errorText }}</span>
          </div>
        </div>
        <!--Previous Policy NCB %* ends-->
      </div>
    </div>
  </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import functions from "@/../../masters/functions.js";
import { reactive,onMounted,onUpdated } from "@vue/composition-api";
export default {
  name: "NCBRecovery",
  props: ["ncbRecoveryData","previousPolicyDetailsObj","loaderShowNcb"],
  components: {
    FloatLabel
  },
  setup(props, context) {
    let state = reactive({
    });
    onMounted(()=>{
      ncbApplicableChange();
    });
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
     onUpdated(()=>{
      context.parent.calculateSteps();
      context.parent.enableCalculatePremiumBtn('ncbRecovery');
    })
    function ncbApplicableChange(){
      if(props.ncbRecoveryData.ncbApplicable.value == 'YES'){
        context.root.$set(props.ncbRecoveryData.ncbTakenFrom,'stepsMandatory', true);
        delete props.ncbRecoveryData.ncbTakenFrom.skip;
        context.root.$set(props.ncbRecoveryData.currentYearNcb,'stepsMandatory', true);
        delete props.ncbRecoveryData.currentYearNcb.skip;
        context.root.$set(props.ncbRecoveryData.previousPolicyNcb,'stepsMandatory', true);
        delete props.ncbRecoveryData.previousPolicyNcb.skip;
      }
      else{
        context.root.$set(props.ncbRecoveryData.ncbTakenFrom,'stepsMandatory', false);
        context.root.$set(props.ncbRecoveryData.ncbTakenFrom,'skip', true);
        context.root.$set(props.ncbRecoveryData.currentYearNcb,'stepsMandatory', false);
        context.root.$set(props.ncbRecoveryData.currentYearNcb,'skip', true);
        context.root.$set(props.ncbRecoveryData.previousPolicyNcb,'stepsMandatory', false);
        context.root.$set(props.ncbRecoveryData.previousPolicyNcb,'skip', true);
      } 
    }
    function resetNcbData(){
      props.ncbRecoveryData.ncbTakenFrom.value = props.ncbRecoveryData.ncbTakenFrom.oldValue;
      props.ncbRecoveryData.currentYearNcb.value = props.ncbRecoveryData.currentYearNcb.oldValue;
      props.ncbRecoveryData.previousPolicyNcb.value = props.ncbRecoveryData.previousPolicyNcb.oldValue;
    }
    function getApplicableNcb(){
      context.parent.getApplicableNcb();
    }
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      getApplicableNcb,
      ncbApplicableChange,
      resetNcbData

    };
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
.loader-small-ncb img{
  max-width: 30px;
  position: absolute;
  bottom: 16%;
  left: 75%;
}

</style>
